import { Box, Stack, TextField } from "@mui/material";
import {
  DesktopDateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import AutoCompleteList from "components/AutoCompleteList";
import moment from "moment";
import StockHistoryTable from "pages/inventory/history_template/StockHistoryTable";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { dispatch } from "store";
import { getFillingPersonThunk } from "store/reducers/accounts";
import { getFillingPersonStockHistoryThunk } from "store/reducers/inventory/stock/fillingPersonStockSlice";

const FillingPersonStockHistory = () => {
  const [searchParams] = useSearchParams();
  const time = searchParams.get("time");
  const fillingPerson = searchParams.get("fillingPerson");
  const [filter, setFilter] = useState({
    time: time ? moment(time).add(1, "second") : moment(),
    fillingPerson: null,
  });

  useEffect(() => {
    dispatch(
      getFillingPersonStockHistoryThunk({
        time: filter.time?.toISOString(),
        fillingPerson: filter.fillingPerson?.profile?.id ?? "" ,
      })
    );
  }, [filter.fillingPerson, filter.time]);
  const state = useSelector((state) => state.fillingPersonStock);

  useEffect(() => {
    dispatch(getFillingPersonThunk());
  }, []);
  const fillingPersons = useSelector((state) => state.accounts.fillingPersons);

  useEffect(() => {
    if (fillingPerson && fillingPersons) {
      const dist = fillingPersons.find((item) => item.id ===  parseInt(fillingPerson));
    //   console.log(dist)
      if(dist){
        setFilter((state) => ({ ...state, fillingPerson: dist }));
      }
      
    }
  }, [fillingPerson, fillingPersons]);
  return (
    <Box padding={2}>
      <Stack direction="row" justifyContent="center" spacing={1.5} marginY={2}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DesktopDateTimePicker
            label="Pick a date"
            value={filter.time}
            onChange={(value) => setFilter({ ...filter, time: value })}
            renderInput={(params) => (
              <TextField variant="outlined" fullWidth {...params} />
            )}
          />
        </LocalizationProvider>

        <AutoCompleteList
          items={fillingPersons}
          name="username"
          label="Filter filling person"
          setValue={(value) => ({ ...filter, fillingPerson: filter.fillingPerson })}
          value={filter.fillingPerson}
        />
      </Stack>
      <StockHistoryTable items={state.history} />
    </Box>
  );
};

export default FillingPersonStockHistory;
